import { render } from "./DiscountGroupsCreate.vue?vue&type=template&id=45664fa8&scoped=true"
import script from "./DiscountGroupsCreate.vue?vue&type=script&lang=js"
export * from "./DiscountGroupsCreate.vue?vue&type=script&lang=js"

import "./DiscountGroupsCreate.vue?vue&type=style&index=0&id=45664fa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45664fa8"]])

export default __exports__